
const Avatar = {
    styleOverrides: {
        root: ({ ownerState, theme }) => {
            return {
                backgroundColor: theme.palette.primary[5],
                border: `1px solid ${theme.palette.primary[20]}`,
                color: theme.palette.primary[20]
            }
        },
    }
}

export default Avatar